export const notificationConstants = {
  GET_ALL_SUCCESS: 'Get all notifications success',
  GET_ALL_FAILURE: 'Get all notifications failure',

  READ_SUCCESS: 'Read notification success',
  UNREAD_SUCCESS: 'Unread notification success',
  READ_FAILURE: 'Read notification failure',

  READ_ALL_SUCCESS: 'Read all notification success',
  READ_ALL_FAILURE: 'Read all notification failure',
  GET_ACTION_CABLE_NOTIFICAIONS: 'get action cable notifications',
  UNREAD_NOTIFICAITON_COUNT: 'unread notifcation count',
  WORKSPACE_SHOW_FROM_NOTIFICATION: 'Show workspace from notification',
  DELETE_ACTION_CABLE_NOTIFICATIONS: 'DELETE_ACTION_CABLE_NOTIFICATIONS',
  UPDATE_NOTIFICATION_RING: 'Updated notification ring successfully',
  UPDATE_NOTIFICATION_RING_FAILURE: 'Update notification ring failed',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION', 


  SET_NOTIFICATION_LIST: 'SET_NOTIFICATION_LIST',
  SET_NOTIFICATION_LIST_HAS_MORE: 'SET_NOTIFICATION_LIST_HAS_MORE',
  UPDATE_NOTIFICATION_LIST_ITEM: 'UPDATE_NOTIFICATION_LIST_ITEM',
  UPDATE_NOTIFICATION_LIST_ITEM_AND_UNREAD: 'UPDATE_NOTIFICATION_LIST_ITEM_AND_UNREAD',
  DELETE_NOTIFICATION_LIST_ITEM: 'DELETE_NOTIFICATION_LIST_ITEM',
  APPEND_NOTIFICATION_LIST: 'APPEND_NOTIFICATION_LIST',

  SET_NEW_NOTIFICATION: 'SET_NEW_NOTIFICATION'
};


export const notificationFilterConstants = {
  GET_NOTIFICATION_FILTER_SUCCESS: 'GET_NOTIFICATION_FILTER_SUCCESS',
  UPDATE_NOTIFICATION_FILTER_SUCCESS: 'UPDATE_NOTIFICATION_FILTER_SUCCESS',
  NOTIFICATION_FILTER_FAILURE: 'NOTIFICATION_FILTER_FAILURE',

  SELECT_NOTIFICATION_FILTER: 'SELECT_NOTIFICATION_FILTER',
  UPDATE_NOTIFICATION_FILTER: 'UPDATE_NOTIFICATION_FILTER',
  SET_NOTIFICATION_FILTER: 'SET_NOTIFICATION_FILTER',
  NOTIFICATION_FILTERS: {
    comments: 'comments',
    mentions: 'mentions',
    status: 'status',
    reminders: 'reminders'
  },

  GET_ORGANIZATION_FILTERS: 'GET_ORGANIZATION_FILTERS',
  TOGGLE_UNSELECTED_ORGANIZATION: 'TOGGLE_UNSELECTED_ORGANIZATION',
  TOGGLE_UNSELECTED_WORKSPACE: 'TOGGLE_UNSELECTED_WORKSPACE',
  RESET_ORGANIZATION_AND_WORKSPACE_FILTERS: 'RESET_ORGANIZATION_AND_WORKSPACE_FILTERS',
  SET_UNSELECTED_ORGANIZATION_IDS: 'SET_UNSELECTED_ORGANIZATION_IDS',
  SET_UNSELECTED_WORKSPACE_IDS: 'SET_UNSELECTED_WORKSPACE_IDS',
}